export default __webpack_public_path__ + "static/media/100_39408.816dcf6d.jpg";